import { Link, useLocation } from 'react-router-dom';
import * as S from './style';
import FooterDropDown from './components/FooterDropDown';
import { useMobileDimensions } from '@app/hooks';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function FooterMenuList({
  menu,
  activeMenu,
  handleToggleMenu,
}: any) {
  const { isMobile } = useMobileDimensions();
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    // 페이지 이동 시 스크롤 최상단으로 이동
    window.scrollTo(0, 0);
  }, [location.pathname]); // pathname이 변경될 때마다 실행

  return (
    <S.FooterMenuLi>
      <div>
        <Link to={menu.link}>{menu.title}</Link>
        {/*{menu.dropdown && (*/}
        {/*  <FooterDropDown*/}
        {/*    isActive={menu.dropdown && activeMenu === menu.title}*/}
        {/*    onClick={() => handleToggleMenu(menu.title)}*/}
        {/*  />*/}
        {/*)}*/}
      </div>
      {isMobile ? (
        menu.dropdown &&
        activeMenu === menu.title && (
          <S.FooterSubMenuUl
            initial={{ maxHeight: 0, opacity: 0 }}
            animate={{ maxHeight: 500, opacity: 1 }}
            transition={{ duration: 0.5 }}
            isActive={activeMenu === menu.title}
          >
            {menu.subMenu.map((subMenu: any, index: number) => (
              <li key={`submenu-${index}-${subMenu.title}`}>
                <Link to={subMenu.link}>{subMenu.title}</Link>
              </li>
            ))}
          </S.FooterSubMenuUl>
        )
      ) : (
        <S.FooterSubMenuUl
          initial={{ maxHeight: 0, opacity: 0 }}
          animate={{ maxHeight: 500, opacity: 1 }}
          transition={{ duration: 0.5 }}
          isActive={activeMenu === menu.title}
        >
          {menu.subMenu.map((subMenu: any, index: number) => (
            <li key={`submenu-${index}-${subMenu.title}`}>
              <Link to={subMenu.link}>{subMenu.title}</Link>
            </li>
          ))}
        </S.FooterSubMenuUl>
      )}
    </S.FooterMenuLi>
  );
}
